export default __webpack_public_path__ + "static/media/iconeEscopoDeQualificação.9da16e72.png";